import React from 'react'
import moment from 'moment'
import styled from 'styled-components'

const StyledMatchInfo = styled.ul`
    font-size: 1.3rem;
    line-height: 1.8rem;
    margin-bottom: 0;
    margin-right: 20px;
    list-style-type: none;

    li {
        margin-bottom: 0;
    }

    @media (max-width: 700px) {
        grid-column: 1;
        display: inline-block;
        position: absolute;
        top: -20px;
        width: 100%;
        text-align: center;
        font-size: 1.1rem;

        li {
            display: inline-block;
            margin-right: 3px;
        }
    }
`

class MatchInfo extends React.PureComponent {
    render() {
        const { match, circlePhase } = this.props

        const playedAt = moment(match.playedAt).format('MMM Do h:mm a')

        let zoneText = null
        if (circlePhase && typeof circlePhase.index === 'number') {
            const phase = circlePhase.index
            const status = circlePhase.status
            const isMoving = status === 2
            const progressPercent = typeof circlePhase.progress === 'number'
                ? Math.round(circlePhase.progress * 100)
                : null

            if (isMoving) {
                zoneText = `Zone: moving (phase ${phase}${progressPercent != null ? `, ${progressPercent}%` : ''})`
            } else {
                zoneText = `Zone: waiting (phase ${phase})`
            }
        }

        return (
            <StyledMatchInfo>
                <li>{playedAt}</li>
                {zoneText && <li>{zoneText}</li>}
            </StyledMatchInfo>
        )
    }
}


export default MatchInfo



// WEBPACK FOOTER //
// ./src/components/MatchPlayer/MatchInfo.js